import Request from "../Request";

const FFSOLAR_SERVER_URL = window.runtimeConfig?.FFSOLAR_SERVER_URL;

const airteam3DViewer = {
  getModelPreview(modelId) {
    return Request.get(
      `/project/airteam-viewer/api/v1/viewer-model-preview/${modelId}/`
    );
  },
  getXlsx(data) {
    return Request.getCsv(`/project/airteam-viewer/export-annotation/`, data);
  },
  getFfSolarObjectsByProjectId(projectId) {
    if (!projectId) return Promise.reject(new Error("Project ID is required"));

    return Request.get(
      `${FFSOLAR_SERVER_URL}/ffsolarobject?projectId=${projectId}`
    );
  },
  createObject(data) {
    return Request.post(`${FFSOLAR_SERVER_URL}/ffsolarobject`, data);
  },
  patchObject(id, show) {
    if (!id) return Promise.reject(new Error("ID is required"));
    return Request.patch(`${FFSOLAR_SERVER_URL}/ffsolarobject/${id}`, {
      show: show,
    });
  },
  patchSolarAreaObject(data, id) {
    if (!id) return Promise.reject(new Error("ID is required"));
    return Request.patch(`${FFSOLAR_SERVER_URL}/ffsolarobject/${id}`, data);
  },
  updateObject(data) {
    return Request.put(`${FFSOLAR_SERVER_URL}/ffsolarobject`, data);
  },
  deleteObject(id) {
    if (!id) return Promise.reject(new Error("ID is required"));
    return Request.delete(`${FFSOLAR_SERVER_URL}/ffsolarobject/${id}`);
  },
  deleteBulkPanelObjects(data) {
    return Request.delete(`${FFSOLAR_SERVER_URL}/ffsolarobject/bulk`, data);
  },
  getCustomPanels(projectId) {
    let url = `${FFSOLAR_SERVER_URL}/custompaneltype`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }
    return Request.get(url);
  },
  createCustomPanel(data) {
    return Request.post(`${FFSOLAR_SERVER_URL}/custompaneltype`, data);
  },
  updateCustomPanel(data) {
    return Request.patch(`${FFSOLAR_SERVER_URL}/custompaneltype`, data);
  },
  deleteCustomPanel(panelId) {
    return Request.delete(`${FFSOLAR_SERVER_URL}/custompaneltype`, {
      id: panelId,
      is_deleted: true,
    });
  },
  updateLikedPanel(data) {
    return Request.post(`${FFSOLAR_SERVER_URL}/likedpanel`, data);
  },
  unlikePanel() {
    return Request.delete(`${FFSOLAR_SERVER_URL}/likedpanel`);
  },
  getDefaultPanelTypes() {
    return Request.get(`${FFSOLAR_SERVER_URL}/paneltype`);
  },
  createPanelObject(data) {
    return this.createObject({ type: "PANEL", ...data });
  },
  createBulkPanelObjects(array) {
    return Request.post(`${FFSOLAR_SERVER_URL}/ffsolarobject/bulk`, array);
  },
  createAreaObject(data) {
    return this.createObject({ type: "AREA", ...data });
  },
  createMeasurementObject(data) {
    return this.createObject({ type: "MEASUREMENT", ...data });
  },
  createMeasurementAreaObject(data) {
    return this.createObject({ type: "AREA_MEASUREMENT", ...data });
  },
  createSolarGroupObject(data) {
    return this.createObject({ type: "SOLAR_GROUP", ...data });
  },
  updateAreaObject(data) {
    return this.updateObject({ type: "AREA", ...data });
  },
  updateMeasurementObject(data) {
    return this.updateObject({ type: "MEASUREMENT", ...data });
  },
  updateMeasurementAreaObject(data) {
    return this.updateObject({ type: "AREA_MEASUREMENT", ...data });
  },
  updatePanelObject(data) {
    return this.updateObject({ type: "PANEL", ...data });
  },
  updateSolarGroupObject(data) {
    return this.updateObject({ type: "SOLAR_GROUP", ...data });
  },
  patchSolarGroupObject(id, data) {
    if (!id) return Promise.reject(new Error("ID is required"));
    return Request.patch(`${FFSOLAR_SERVER_URL}/ffsolarobject/${id}`, data);
  },
  updateBulkPanelObject(array) {
    return Request.put(`${FFSOLAR_SERVER_URL}/ffsolarobject/bulk`, array);
  },
  getDefaultValues() {
    return Request.get(`${FFSOLAR_SERVER_URL}/defaults`);
  },
  getLikedPanel() {
    return Request.get(`${FFSOLAR_SERVER_URL}/likedpanel`);
  },
  updateDefaultValues(data) {
    return Request.put(`${FFSOLAR_SERVER_URL}/defaults`, data);
  },

  getProjectConfig(id) {
    return Request.get(`${FFSOLAR_SERVER_URL}/projects/${id}/config`);
  },
  putProjectConfig(id, data) {
    if (!data) {
      console.error("Payload data is missing or undefined");
      return;
    }

    return Request.put(`${FFSOLAR_SERVER_URL}/projects/${id}/config`, data);
  },
  getCameras(id, params = {}) {
    const { mode, page, pageSize, categoryId } = params;
    let url = `/project-camera/api/v1/cameras/?project_id=${id}`;
    if (mode) url += `&mode=${mode}`;
    if (page != null) url += `&page=${page}`;
    if (pageSize != null) url += `&page_size=${pageSize}`;
    if (categoryId != null) url += `&category_id=${categoryId}`;
    return Request.get(url);
  }
};

export default airteam3DViewer;
